import { render, staticRenderFns } from "./detail_local_delivery.vue?vue&type=template&id=682b117b&scoped=true"
import script from "./detail_local_delivery.vue?vue&type=script&lang=js"
export * from "./detail_local_delivery.vue?vue&type=script&lang=js"
import style0 from "./detail_local_delivery.vue?vue&type=style&index=0&id=682b117b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682b117b",
  null
  
)

export default component.exports